import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';

type ScrollToTopButtonProps = {
    visible: boolean;
    onClick: () => void;
    className?: string;
};

export function ScrollToTopButton({ visible, onClick, className = '' }: ScrollToTopButtonProps) {
    return (
        <div className={`sticky z-20 flex h-0 justify-center ${className}`}>
            <button
                type="button"
                onClick={onClick}
                className={`flex h-11 w-11 items-center justify-center rounded-full border border-slate-grey-200 bg-white shadow-lg transition-all duration-300 hover:border-slate-grey md:h-9 md:w-9 ${
                    visible ? 'translate-y-0 opacity-100' : 'pointer-events-none -translate-y-3 opacity-0'
                }`}
                aria-label="Scroll to top"
            >
                <FontAwesomeIcon icon={faArrowUp} className="text-sm text-slate-grey" />
            </button>
        </div>
    );
}
